import T from '../types';
import getMetaData from '../../../utility/getMetaData';

const getSearchData = (from, to) => ({
  promise: async () => {
    if (!from || !to) {
      return Promise.reject();
    }

    try {
      // eslint-disable-next-line vars-on-top, no-var
      var [metaFrom, metaTo] = await Promise.all([getMetaData(from), getMetaData(to)]);
    } catch (err) {
      return Promise.reject(err);
    }

    // eslint-disable-next-line block-scoped-var
    if (!metaFrom || !metaTo || !metaFrom.id || !metaTo.id) {
      return Promise.reject();
    }

    return Promise.resolve({
      // eslint-disable-next-line block-scoped-var
      from: metaFrom,
      // eslint-disable-next-line block-scoped-var
      to: metaTo,
    });
  },
  types: [T.GET_SEARCH_DATA, T.GET_SEARCH_DATA_SUCCESS, T.GET_SEARCH_DATA_FAIL],
});

export default getSearchData;
